import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

interface ParamsCTXRList {
  cloud?: string;
  region?: string;
}

export function getCTXRlistGlobal(
  subscriptionId: number,
  tenant: number,
  token: string,
  cloud?: string,
  region?: string
) {
  const params: ParamsCTXRList = {};
  if (cloud !== undefined) params.cloud = cloud;
  if (region !== undefined) params.region = region;

  return axios.get(
    `${API_URL}/v1/ctxr/${subscriptionId}/listSelector?tenantId=${tenant}`,
    {
      params,
      headers: { Authorization: `Bearer ${token}` },
    }
  );
}

/** 2) NUEVO: para GET /v1/ctxr/listneighbor/:ctxrId?tenantId=... */
export function getNeighborsListByCtxrId(
  token: string,
  ctxrId: string,
  tenantId: number
) {
  return axios.get(`${API_URL}/v1/ctxr/listneighbor/${ctxrId}?tenantId=${tenantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * 2) GET /v1/ctxr/-1/statusneighbor?tenantId=1
 */
export function getNeighborsStatus(token: string) {
  return axios.get(`${API_URL}/v1/ctxr/-1/statusneighbor?tenantId=1`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * POST /v1/ctxr/bgpsumary/{ctxrId}?tenantId=1
 */
export function postBgpSummary(
  token: string,
  ctxrId: string,
  tenantId: number,
  payload: { neighbor: string; type: string }
) {
  return axios.post(
    `${API_URL}/v1/ctxr/bgpsumary/${ctxrId}?tenantId=${tenantId}`,
    payload,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
}

/** Interfaz específica para getLogsByCtxrId params */
interface GetLogsByCtxrIdParams {
  tenantId: number;
  fecha: string;
  fechastart: string;
  timestart: string;
  time: string;
  level?: string;
  search?: string;
}

/**
 * NUEVO:
 * GET /v1/ctxr/logs/{ctxrId}?tenantId=...&fecha=...&fechastart=...&timestart=...&time=...&[level=...]&[search=...]
 */
export function getLogsByCtxrId(
  token: string,
  ctxrId: string,
  tenantId: number,
  fecha: string,
  fechaStart: string,
  timeStart: string,
  time: string,
  level?: string,
  search?: string
) {
  const params: GetLogsByCtxrIdParams = {
    tenantId,
    fecha,
    fechastart: fechaStart,
    timestart: timeStart,
    time,
  };
  if (level) {
    params.level = level;
  }
  if (search) {
    params.search = search;
  }

  return axios.get(`${API_URL}/v1/ctxr/logs/${ctxrId}`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
}
